import { Mutation } from "react-query";

import { getErrorCode } from "src/utils/getErrorMessage";

// The app-wide MutationCache onError used by pages/_app.tsx. A mutation can opt out of this
// error toast by setting `meta: { skipGlobalErrorToast: true }` when it already surfaces its own
// friendly error UI (inline banner / component toast). This prevents the raw error-code toast
// from stacking on top of a component's handled error (e.g. the affiliate-product duplicate flow
// shows its own friendly toast).
export const createGlobalMutationErrorHandler =
  (showErrorToast: (errorCode: string) => void) =>
  (
    error: unknown,
    _variables: unknown,
    _context: unknown,
    mutation?: Mutation<unknown, unknown, unknown, unknown>
  ) => {
    if (mutation?.options?.meta?.skipGlobalErrorToast) {
      return;
    }
    showErrorToast(getErrorCode(error));
  };
